var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',{attrs:{"loading":_vm.loading,"disabled":!_vm.facilityName,"text":"","color":"primary"},on:{"click":_vm.getPackage}},[_c('v-icon',{attrs:{"left":""}},[_vm._v(" mdi-robot-industrial ")]),_vm._v(" Provision ")],1)
}
var staticRenderFns = []

export { render, staticRenderFns }